// Date 2023-02-23 14:43:08

import sithMesCustomer from "@/store/sithMes/customer/SithMesCustomerStore.js";

const genericEntities = [
    'sithMesCustomer'
]

const entities = {
    sithMesCustomer
}

export {genericEntities}

export default entities